<template>
    <div id="prompt-box" class="popup">
        <div class="prompt-body fixed-box s-content">
            <div class="head">
                <span>{{$root.prompt[0]&&$root.prompt[0].text?(($root.prompt[0]&&$root.prompt[0].text)||last.text):"&nbsp;"}}</span>
                <button class="close" @click="cancel"></button>
            </div>
            <div class="body">
                <table class="prompt-table edit mb20">
                    <tbody>
                        <tr v-for="(i,index) in ($root.prompt[0]?$root.prompt[0].data:last.data)" :key="'a'+index">
                            <template v-if="i.type=='text'||i.type==undefined">
                                <td><strong class="required" v-if="i.required">*</strong>{{i.name}}：</td>
                                <td>
                                    <input v-if="i.password" type="password" :placeholder="i.placeholder" v-model="i.value" class="focus" :required="i.required" autocomplete="new-password">
                                    <input v-else v-model="i.value" :placeholder="i.placeholder" class="focus" :required="i.required">
                                </td>
                            </template>
                            <template v-if="i.type=='select'">
                                <td><strong class="required" v-if="i.required">*</strong>{{i.name}}：</td>
                                <td>
                                    <drop-down :data="i.list" :width="'100%'" @output="i.value=$event.value" :class="{invalid:i.required&&(i.value==''||i.value==undefined)}"></drop-down>
                                </td>
                            </template>
                            <template v-if="i.type=='plugin'">
                                <td><strong class="required" v-if="i.required">*</strong>{{i.name}}：</td>
                                <td>
                                    <div class="focus" v-if="i.plugin=='datepicker'">
                                        <input class="date-input" placeholder>
                                        <date-picker v-model="i.value" :input-class="['focus','h32']" :class="{invalid:i.value==''}"></date-picker>
                                    </div>
                                    <!-- <div class="focus" v-if="i.plugin=='vue-clock-picker'">
                                        <vue-clock-picker @timeset="i.value=$event" :value="i.value" :class="{invalid:i.value==''}" :input-class="'focus h32'"></vue-clock-picker>
                                    </div> -->
                                </td>
                            </template>
                        </tr>
                    </tbody>
                </table>
                <div class="action-bts">
                    <button class="action-bt reset" @click="reset" :disabled="!avail">重置</button>
                    <button class="action-bt add main" @click="confirm" :disabled="!avail">确定</button>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
    .prompt-body {
        position: relative;
        max-width: 500px;
    }

    .content {
        align-items: center;
        color: #353535;
        font-size: 16px;
        margin-bottom: 20px;
    }

    .content img {
        margin-right: 18px;
    }

    .content h3 {
        margin: 0 0 20px 0;
        text-align: center;
        font-size: 18px;
        font-weight: normal;
        color: #333;
    }

    .prompt-table td:last-child {
        font-size: 14px !important;
    }

    .prompt-table {
        width: 100%;
    }

    .prompt-table td:first-child {
        text-align: right;
    }

    .prompt-table input {
        width: 100%;
    }

    .bts {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .bts button {
        width: 148px;
        font-size: 16px;
        height: 46px;
    }

    .bts .yes {
        border: 1px solid #c4a66a;
        color: #c4a66a;
        margin-right: 30px;
    }

    .bts .no {
        border: 1px solid #b2b2b2;
        color: #b2b2b2;
    }

    .close:hover {
        opacity: .7;
    }
</style>
<script>
    // 示例：
    // var that=this;
    // this.$root.prompts.push({
    //     title: "修改备注",
    //     data: [{
    //         name: "备注留言",
    //         value: ""
    //     }],
    //     fn: function () {
    //       console.log(this.data[0].value)
    //     }
    // });
    import $ from 'jquery'
    export default {
        data: function () {
            return {
                last: {}
            }
        },
        computed: {
            avail: function () {
                var ret = true;
                if (!this.$root.prompt[0]) return false;
                $.each(this.$root.prompt[0].data, function (index, item) {
                    if (item.required && item.value == "") {
                        ret = false;
                    }
                });
                return ret;
            }
        },
        methods: {
            confirm: function () {
                if (!this.$root.prompt[0].keep) {
                    this.last = this.$root.prompt.shift();
                    this.last.fn();
                } else {
                    this.$root.prompt[0].fn();
                }
            },
            cancel: function () {
                this.last = this.$root.prompt.shift();
            },
            reset: function () {
                for (var i = 0; i < this.$root.prompt[0].data.length; i++) {
                    this.$root.prompt[0].data[i].value = ''
                }
            }
        }
    }
</script>